module.exports = __webpack_public_path__ + "img/enovos.a3f649f3.png";